import * as React from 'react';
import './myPageNavigation.module.scss';
import { observer } from 'mobx-react';
import { SideBar } from './SideBar';
import { BackButtonHeader } from './BackButtonHeader';
import { V3Routes } from '../../../routes';
import { routingStore } from '../../../../common/stores/routing';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';

type Props = {};

@observer
export class MyPageNavigation extends React.Component<Props> {
    render() {
        if (GlobalStatesV3.viewport.isDesktop) {
            routingStore.push(V3Routes.home());
        }
        return (
            <div styleName="my-page">
                <BackButtonHeader to={V3Routes.home()} />
                <div styleName="title">MENU</div>
                <div styleName="sub-title">メニュー</div>
                <SideBar />
            </div>
        );
    }
}
